import { Grid } from "@mui/material";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import { useAuthContext } from "../../../../hooks/Auth";
import { Spinner } from "../../../Loading/Spinner";
import CreateUserModal from "./CreateUserModal";
import DeleteUserModal from "./DeleteUserModal";
import EditUserModal from "./EditUserModal";
import HeadersUsersTable from "./HeadersUsersTable";
import { SingleOrgUsersTable } from "./SingleOrgUsersTable";

const SingleOrgUsers = () => {
  const {
    isLoadingUsers,
    isEditUserModalOpen,
    isEditingUser,
    toggleEditUserModal,
    selectedUser,
    userEdit,
  } = useSuperAdminSingleOrg();

  if (isLoadingUsers) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: 3,
        width: "100%",
        marginX: "auto",
        paddingX: 4,
      }}
    >
      {/* Searchbar y crear usuario */}
      <Grid item>
        <HeadersUsersTable />
      </Grid>

      {/* Tabla de usuarios */}
      <Grid item>
        <SingleOrgUsersTable />
      </Grid>

      {/* Modal para crear usuario */}
      <Grid item>
        <CreateUserModal />
      </Grid>

      {/* Modal para editar usuario */}

      <Grid item>
        <EditUserModal
          isEditModalOpen={isEditUserModalOpen}
          isEditing={isEditingUser}
          toggleEditModal={toggleEditUserModal}
          usuarioSeleccionado={selectedUser}
          userEdit={userEdit}
        />
      </Grid>

      {/* Modal para borrar usuario */}
      <Grid item>
        <DeleteUserModal />
      </Grid>
    </Grid>
  );
};

export default SingleOrgUsers;
